import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Link as Link1 } from 'react-scroll'

import logoDark from '../assets/images/logo-dark.png'
import logoLight from '../assets/images/logo-light.png'
import { FiUser } from 'react-icons/fi'
import type { AppDispatch } from '../redux/store';
import { useDispatch } from 'react-redux';  

export default function Navbar({
    navLight,
    playBtn,
    bgLight,
    navCenter
}: {
    navLight: boolean
    playBtn: boolean
    bgLight: boolean
    navCenter: boolean
}) {
    const [menu, setMenu] = useState<boolean>(false)
    const [scroll, setScroll] = useState<boolean>(false)
    const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false)
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
        const handlerScroll = () => {
            setScroll(window.scrollY > 50)
        }

        window.addEventListener('scroll', handlerScroll)

        return () => {
            window.removeEventListener('scroll', handlerScroll)
        }
    }, [])

    useEffect(() => {
        const token = localStorage.getItem('token')
        setIsLoggedIn(!!token)
    }, [])

    const handleLogout = () => {
        localStorage.removeItem('token')
        localStorage.clear();
        dispatch({ type: 'RESET_APP' });
        setIsLoggedIn(false)
        navigate('/auth?mode=login')
    }

    return (
        <nav
            className={`navbar ${bgLight ? 'bg-white dark:bg-slate-900 shadow dark:shadow-gray-800' : ''
                } ${scroll ? 'is-sticky' : ''}`}
            id="navbar"
        >
            <div className="container relative flex flex-wrap items-center justify-between">
                <Link className="navbar-brand md:me-8" to="/">
                    <img src={scroll ? logoLight : logoDark} className="h-[80px]" />
                </Link>

                <div className="nav-icons flex items-center lg_992:order-2 md:ms-6">
                    {!playBtn && (
                        <ul className="list-none menu-social mb-0">
                            {!isLoggedIn ? (
                                <>
                                    <li className="inline">
                                        <Link
                                            to="/auth?mode=login"
                                            className="h-8 px-4 text-[12px] tracking-wider inline-flex items-center justify-center font-medium rounded-full bg-red-500 text-white uppercase"
                                        >
                                            login
                                        </Link>
                                    </li>
                                    <li className="inline">
                                        <Link
                                            to="/auth?mode=register"
                                            className="h-8 px-4 text-[12px] tracking-wider inline-flex items-center justify-center font-medium rounded-full bg-red-500 text-white uppercase"
                                        >
                                            Signup
                                        </Link>
                                    </li>
                                </>
                            ) : (
                                <>

                                    <li className="inline">
                                        <Link
                                            to="/dashboard"
                                            className="size-8 inline-flex items-center justify-center rounded-full align-middle bg-red-500 text-red-500 hover:text-white"
                                        >
                                            <FiUser className="size-4" />
                                        </Link>
                                    </li>
                                    <li className="inline">
                                        <button
                                            onClick={handleLogout}
                                            className="h-8 px-4 text-[12px] tracking-wider inline-flex items-center justify-center font-medium rounded-full bg-red-500 text-white uppercase"
                                        >
                                            Logout
                                        </button>
                                    </li>
                                </>
                            )}
                        </ul>
                    )}

                    <button
                        type="button"
                        className="collapse-btn inline-flex items-center ms-2 text-slate-900 dark:text-white lg_992:hidden"
                        onClick={() => setMenu(!menu)}
                    >
                        <span className="sr-only">Navigation Menu</span>
                        <i className="mdi mdi-menu text-[24px]"></i>
                    </button>
                </div>

                <div
                    className={`navigation lg_992:order-1 lg_992:flex  ${navCenter ? '' : 'ms-auto'
                        } ${menu ? '' : 'hidden'} text-center lg:text-left`}
                    id="menu-collapse"
                >
                    <ul className={`navbar-nav ${navLight ? '' : ''}`} id="navbar-navlist">
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="home">
                                Home
                            </Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="features">
                                Features
                            </Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="screenshot">
                                Application
                            </Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="faqs">
                                FAQs
                            </Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="download">
                                Download
                            </Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="reviews">
                                Reviews
                            </Link1>
                        </li>
                        <li className="nav-item ms-0">
                            <Link1 className="nav-link" activeClass="active" spy={true} smooth={true} duration={500} to="contact">
                                Contact us
                            </Link1>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}
